import React from "react";

export default function Marquee({
  text = "THE KNOW IT OWLS · CLASS IS IN SESSION · ROLL CALL · DETENTION NEVER LOOKED THIS GOOD",
  bg = "var(--st-maroon)",
  color = "#F5EBD0",
  reverse = false,
  /* angle band running underneath for the "X" / overlapping look from the design ref */
  accentBg = "var(--st-mustard)",
  testId = "marquee-strip",
}) {
  const repeated = Array(10).fill(text);
  return (
    <div
      data-testid={testId}
      className="relative overflow-hidden select-none"
      style={{ paddingTop: 56, paddingBottom: 56 }}
    >
      {/* angled accent band — slightly gentler tilt so the rotated corners
          never get clipped by the parent's overflow on wide viewports. */}
      <div
        className="absolute left-[-15%] right-[-15%] h-[44px] border-y-2 border-[#111]"
        style={{
          top: "50%",
          transform: "translateY(-50%) rotate(-2.5deg)",
          background: accentBg,
        }}
        aria-hidden
      />

      {/* main marquee band */}
      <div
        className="relative border-y-2 border-[#111] py-2.5"
        style={{ background: bg, color }}
      >
        <div
          className={`flex whitespace-nowrap ${reverse ? "marquee-track-reverse" : "marquee-track"}`}
        >
          {repeated.map((t, i) => (
            <span
              key={i}
              className="font-display uppercase text-2xl md:text-3xl tracking-tight px-6 flex items-center gap-6"
            >
              {t}
              <span
                className="inline-block w-3 h-3 rotate-45"
                style={{ background: "currentColor" }}
              />
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
